
import { v4 } from "uuid";
import { IPrintResult } from "domains/order/agreggates/print/IPrintResult";
import { ICefSharpPrintService } from "../cefSharpService/local/Interfaces/_ICefSharpPrintService";
import { IPrintRepository } from "domains/order/interfaces/repositories/iprintRespository";
import { Ticket } from "domains/order/agreggates/ticket/ticket";
import { EletronicInvoiceTicket } from "domains/order/agreggates/EletronicInvoiceTicket/EletronicInvoiceTicket";
import { OrderResume } from "domains/order/agreggates/order/OrderResume";
import { ICefSharp } from "../cefSharpService/local/Interfaces/_ICefSharp";
import { printBase64, printString } from "modules/reactNativeBridge/ReactNativeBridge";

declare const CefSharp: ICefSharp;
declare const printService: ICefSharpPrintService;




export const ReactNativePrintRepository = (): IPrintRepository => {
  const printOrderAsync = async (ticket: Ticket): Promise<IPrintResult> => {
    throw new Error("Método não implementado");
  };

  const printEletronicInvoiceAsync = async (
    eletronicInvoiceTicket: EletronicInvoiceTicket
  ): Promise<IPrintResult> => {
    throw new Error("Método não implementado");
  };

  const printImage = async (ImageToPrint: string): Promise<IPrintResult> => {
    return printBase64(ImageToPrint);
  };

  const printResumeAsync = async (
    orderResume: OrderResume
  ): Promise<IPrintResult> => {
    throw new Error("Método não implementado");
  };

  const printStringAsync = async (
    text: string
  ): Promise<IPrintResult> => {
    return printString(text);
  };

  const remotePrintAsync = async (
    uri: string,
    orderResume: OrderResume
  ): Promise<boolean> => {
    // throw new Error("Método não implementado...");
    return true;
  };

  return {
    printOrderAsync,
    printEletronicInvoiceAsync,
    printResumeAsync,
    remotePrintAsync,
    printStringAsync,
    printImage,
  };
};
